import ListItemButton from '@components/v2/ui/List/ListItemButton';
import ListItemText from '@components/v2/ui/List/ListItemText';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import { memo } from 'react';
import { OptionValue } from '../../../../../../../lib/OptionsLib';
import useStyles from './option.styles';

export const OPTION_WITH_SECONDARY_CLASS = 'option-with-secondary';

export interface GroupedOptionParams {
  isExpanded: boolean;
  hasSelectedOptions: boolean;
  hasAllSelectedOptions: boolean;
  handleSelectAll: () => void;
  toggleExpandable: () => void;
}

export interface OptionParams {
  isSelected: boolean;
  onSelect: (optionValue: OptionValue) => void;
}

interface OptionProps {
  value: OptionValue;
  label: string;
  isVisible: boolean;
  params: GroupedOptionParams | OptionParams;
  isChildren?: boolean;
}

const Option = ({ label, value, isVisible, params, isChildren }: OptionProps) => {
  const { classes, cx } = useStyles();

  const textArray = label.split('\n');
  const hasSecondaryText = textArray.length > 1;

  const isGroupedOption = 'handleSelectAll' in params;

  const onSelect = () => {
    if (isGroupedOption) {
      return params.handleSelectAll();
    }

    return params.onSelect(value);
  };
  const isSelected = isGroupedOption ? params.hasSelectedOptions : params.isSelected;
  const verifyIfIsIndeterminate = () => {
    if (isGroupedOption) {
      return isSelected && !params.hasAllSelectedOptions;
    }

    return false;
  };

  return (
    <ListItemButton
      key={value}
      isActive={isSelected}
      disabled={!isVisible}
      onClick={() => onSelect()}
      className={cx(
        classes.listItem,
        hasSecondaryText && [OPTION_WITH_SECONDARY_CLASS, classes.listItemWithSecondary],
      )}
      sx={{
        gap: 0.5,
        '&.Mui-disabled': { display: 'none' },
        paddingLeft: isChildren ? '24px' : undefined,
      }}
    >
      <Checkbox
        disableRipple
        checked={isSelected}
        size="small"
        indeterminate={verifyIfIsIndeterminate()}
      />
      <Box
        sx={{
          flexDirection: 'column',
          width: 'fill-available',
          minWidth: 0,
        }}
      >
        <ListItemText
          primary={textArray[0]}
          secondary={textArray[1]}
          slotProps={{
            root: { title: textArray[0] },
            primary: { noWrap: true },
            secondary: { noWrap: true },
          }}
          className={classes.optionText}
        />
      </Box>
    </ListItemButton>
  );
};

export default memo(Option);
